var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllPlansUpgradeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2723,
    cy: 30.8847,
    rx: 29.2723,
    ry: 29.1153,
    fill: "#B2BBEE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.5363,
    cy: 20.3406,
    rx: 1.98383,
    ry: 1.97319,
    fill: "#465DD8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1991,
    cy: 41.7852,
    rx: 2.8007,
    ry: 2.78568,
    fill: "#465DD8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.0202,
    cy: 2.08926,
    rx: 2.10053,
    ry: 2.08926,
    fill: "#465DD8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.95358,
    cy: 21.8212,
    rx: 1.16696,
    ry: 1.1607,
    fill: "#465DD8"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0954,
    cy: 2.99743,
    rx: 1.16696,
    ry: 1.1607,
    fill: "#465DD8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.4084,
    cy: 48.3035,
    rx: 1.16696,
    ry: 1.1607,
    fill: "#465DD8"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02876,
    cy: 38.9995,
    rx: 1.86713,
    ry: 1.85712,
    fill: "#465DD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9761 11.0132C47.0574 11.094 47.1109 11.1983 47.129 11.3112C47.3531 13.9473 47.1246 16.6021 46.4531 19.1619L38.8544 11.5226C41.405 10.8617 44.0503 10.638 46.6766 10.8612C46.79 10.8792 46.8949 10.9324 46.9761 11.0132ZM27.598 18.8366L20.2392 30.5368C20.1734 30.6408 20.1451 30.764 20.159 30.8862C20.1728 31.0084 20.228 31.1222 20.3155 31.2091L26.6714 37.5309C26.7218 37.5821 26.782 37.6228 26.8485 37.6508C26.9149 37.6787 26.9863 37.6932 27.0584 37.6935C27.1613 37.6941 27.2619 37.6639 27.3473 37.6068L39.1487 30.2548C42.4755 27.7773 44.9215 24.3093 46.1314 20.3547L37.6551 11.8533C33.6396 13.0542 30.1155 15.5012 27.598 18.8366Z",
    fill: "#465DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7606 33.8473C30.2032 35.1251 29.6771 37.2251 29.6462 39.2403C29.6199 40.9585 29.1849 42.6624 28.3561 44.2059C28.2905 44.3118 28.2636 44.4369 28.2797 44.5603C28.2958 44.6836 28.3541 44.7977 28.4448 44.8834C28.5029 44.9368 28.572 44.9771 28.6473 45.0014C28.7226 45.0256 28.8024 45.0332 28.8809 45.0237C28.9716 45.0124 29.0579 44.9787 29.132 44.9256C31.3018 43.3778 35.0546 40.2934 36.9673 36.3514C38.545 33.1 34.6623 31.4666 31.8683 33.759L31.7606 33.8473Z",
    fill: "#252A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3147 26.7409C22.9991 28.255 20.8829 28.7503 18.8782 28.7276C17.1372 28.7079 15.4003 29.1012 13.8178 29.8959C13.7098 29.9586 13.5835 29.9826 13.4599 29.9637C13.3363 29.9448 13.223 29.8842 13.1389 29.7921C13.0865 29.7331 13.0476 29.6635 13.025 29.588C13.0024 29.5126 12.9965 29.4331 13.0079 29.3552C13.0213 29.2653 13.0572 29.1803 13.1123 29.1078C14.7156 26.9889 17.8952 23.3357 21.8932 21.5218C25.2007 20.021 26.697 23.9993 24.3147 26.7409V26.7409Z",
    fill: "#252A5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1152 30.7882C21.1193 30.784 21.12 30.7774 21.1167 30.7725C21.1136 30.7679 21.114 30.7618 21.1177 30.7576C21.1654 30.7041 21.2233 30.6605 21.2881 30.6293C21.3557 30.5968 21.4294 30.5785 21.5045 30.5756C21.5795 30.5727 21.6544 30.5853 21.7243 30.6126C21.7943 30.6398 21.8578 30.6812 21.9109 30.734C21.9641 30.7868 22.0056 30.85 22.033 30.9196C22.0604 30.9892 22.0731 31.0636 22.0702 31.1383C22.0673 31.213 22.0489 31.2862 22.0162 31.3535C21.9835 31.4208 21.9371 31.4806 21.8801 31.5292L20.6645 32.7382C20.5679 32.8451 20.4326 32.9094 20.2884 32.9172C20.1806 32.9167 20.0753 32.8845 19.9859 32.8245C19.8965 32.7646 19.827 32.6796 19.7862 32.5804C19.7453 32.4811 19.735 32.3721 19.7565 32.267C19.7779 32.1619 19.8303 32.0655 19.9068 31.99L21.1152 30.7882ZM15.2789 41.6028L19.0292 37.8563C19.1318 37.7521 19.2719 37.6927 19.4186 37.6911C19.5653 37.6896 19.7066 37.7461 19.8114 37.8482C19.9162 37.9503 19.9759 38.0896 19.9775 38.2355C19.979 38.3814 19.9222 38.522 19.8195 38.6262L16.0475 42.3727C15.9448 42.4741 15.8059 42.5307 15.6612 42.5302C15.5166 42.5297 15.3781 42.4721 15.2761 42.37C15.1742 42.2679 15.1172 42.1297 15.1178 41.9858C15.1183 41.8419 15.1762 41.7042 15.2789 41.6028ZM23.3312 33.9404C23.3345 33.9453 23.3338 33.9519 23.3296 33.9561L22.1213 35.1579C22.0447 35.2335 21.9924 35.3298 21.9709 35.4349C21.9495 35.54 21.9598 35.6491 22.0007 35.7483C22.0415 35.8475 22.111 35.9325 22.2004 35.9924C22.2898 36.0524 22.395 36.0846 22.5028 36.0851C22.6471 36.0774 22.7824 36.013 22.879 35.9061L24.0945 34.6971C24.1516 34.6485 24.1979 34.5887 24.2307 34.5214C24.2634 34.4541 24.2818 34.3809 24.2847 34.3062C24.2876 34.2315 24.2749 34.1571 24.2475 34.0875C24.2201 34.0179 24.1785 33.9547 24.1254 33.9019C24.0723 33.8491 24.0088 33.8077 23.9388 33.7805C23.8689 33.7532 23.794 33.7406 23.7189 33.7435C23.6439 33.7464 23.5702 33.7647 23.5026 33.7972C23.4378 33.8284 23.3799 33.872 23.3321 33.9255C23.3284 33.9297 23.3281 33.9358 23.3312 33.9404ZM26.2174 35.8628C26.2215 35.8587 26.2278 35.858 26.2326 35.8612C26.2373 35.8644 26.2436 35.8637 26.2477 35.8598C26.3496 35.7627 26.4855 35.7086 26.6269 35.7091C26.7716 35.7096 26.9101 35.7672 27.012 35.8693C27.114 35.9714 27.1709 36.1096 27.1704 36.2535C27.1699 36.3973 27.112 36.5351 27.0093 36.6365L25.7937 37.8455C25.6922 37.9457 25.5552 38.0022 25.4122 38.0028C25.3404 38.0032 25.2693 37.9895 25.2029 37.9625C25.1365 37.9355 25.0761 37.8958 25.0251 37.8455C24.9741 37.7951 24.9335 37.7352 24.9058 37.6691C24.8782 37.603 24.8639 37.5322 24.8639 37.4606C24.8639 37.389 24.8782 37.3182 24.9058 37.2521C24.9335 37.186 24.9741 37.1261 25.0251 37.0757L26.2174 35.8628ZM22.6541 39.4124L20.4138 41.6354C20.3627 41.6858 20.3221 41.7457 20.2944 41.8118C20.2668 41.8779 20.2525 41.9487 20.2525 42.0203C20.2525 42.0919 20.2668 42.1627 20.2944 42.2288C20.3221 42.2949 20.3627 42.3548 20.4138 42.4053C20.4647 42.4555 20.5251 42.4953 20.5915 42.5222C20.6579 42.5492 20.729 42.5629 20.8008 42.5625C20.8725 42.5629 20.9436 42.5492 21.0101 42.5222C21.0765 42.4953 21.1369 42.4555 21.1878 42.4053L23.4227 40.1769C23.512 40.0732 23.5587 39.9398 23.5534 39.8033C23.5481 39.6669 23.4912 39.5374 23.3941 39.4409C23.2971 39.3443 23.1669 39.2877 23.0297 39.2825C22.8925 39.2772 22.7584 39.3236 22.6541 39.4124ZM14.5729 37.0519L16.8132 34.829C16.9175 34.7402 17.0516 34.6938 17.1888 34.699C17.326 34.7043 17.4562 34.7609 17.5532 34.8574C17.6503 34.954 17.7072 35.0834 17.7125 35.2199C17.7178 35.3563 17.6711 35.4898 17.5818 35.5935L15.3469 37.8218C15.296 37.8721 15.2356 37.9118 15.1692 37.9388C15.1027 37.9658 15.0316 37.9795 14.9599 37.9791C14.8881 37.9795 14.817 37.9658 14.7506 37.9388C14.6842 37.9118 14.6238 37.8721 14.5729 37.8218C14.5218 37.7714 14.4812 37.7115 14.4535 37.6454C14.4259 37.5793 14.4116 37.5084 14.4116 37.4369C14.4116 37.3653 14.4259 37.2944 14.4535 37.2284C14.4812 37.1623 14.5218 37.1023 14.5729 37.0519Z",
    fill: "#252A5A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdii_73_2770)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.9193,
    cy: 20.4693,
    rx: 4.11725,
    ry: 4.09517,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdii_73_2770",
    x: 12.802,
    y: -3.62585,
    width: 57.2346,
    height: 53.1903,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_73_2770"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0690278 0 0 0 0 0.295833 0 0 0 0 0.11166 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_73_2770",
    result: "effect2_dropShadow_73_2770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_73_2770",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_73_2770"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0199306 0 0 0 0 0.341667 0 0 0 0 0.0521041 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_73_2770",
    result: "effect4_innerShadow_73_2770"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPlansUpgradeIcon);
export default __webpack_public_path__ + "static/media/AllPlansUpgradeIcon.a200f2a0.svg";
export { ForwardRef as ReactComponent };